import React, { useEffect, useState } from "react";
import axios from "axios";
import { Api } from "../Api/Api"; // adjust path if needed

const ProductDetails = () => {
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${Api}product/read.php`);
      const data = Array.isArray(res.data) ? res.data : [res.data];
      setProducts(data);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  // 🔹 Reorder: first matching category/product, then others
  const reorderedProducts = [...products].sort((a, b) => {
    if (!searchTerm) return 0;
    const term = searchTerm.toLowerCase();

    const aMatch =
      a.product.toLowerCase().includes(term) ||
      a.category.toLowerCase().includes(term);
    const bMatch =
      b.product.toLowerCase().includes(term) ||
      b.category.toLowerCase().includes(term);

    if (aMatch && !bMatch) return -1; // a first
    if (!aMatch && bMatch) return 1; // b first
    return 0;
  });

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Product Details</h2>

      {/* Search Box */}
      <input
        type="text"
        placeholder="Search by product or category..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="border p-2 rounded w-full max-w-md mb-4"
      />

      {/* Table */}
      <div className="overflow-x-auto border rounded shadow">
        <table className="min-w-full border-collapse text-sm">
          <thead className="bg-gray-800 text-white">
            <tr>
              <th className="px-3 py-2 border">ID</th>
              <th className="px-3 py-2 border">Category</th>
              <th className="px-3 py-2 border">Product</th>
              <th className="px-3 py-2 border">Barcode</th>
              <th className="px-3 py-2 border">Stock</th>
              <th className="px-3 py-2 border">Price</th>
              <th className="px-3 py-2 border">Image</th>
            </tr>
          </thead>
          <tbody>
            {reorderedProducts.length > 0 ? (
              reorderedProducts.map((prod, idx) => (
                <tr key={prod.id} className="odd:bg-gray-100 hover:bg-gray-50">
                  {/* 🔹 Sequential ID, not DB ID */}
                  <td className="px-3 py-2 border">{idx + 1}</td>
                  <td className="px-3 py-2 border">{prod.category}</td>
                  <td className="px-3 py-2 border">{prod.product}</td>
                  <td className="px-3 py-2 border">{prod.barcode}</td>
                  <td className="px-3 py-2 border">{prod.stock}</td>
                  <td className="px-3 py-2 border">₹{prod.price}</td>
                  <td className="px-3 py-2 border">
                    <img
                      src={prod.image}
                      alt={prod.product}
                      className="h-12 w-12 object-cover rounded"
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-3">
                  No products found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductDetails;
